import { FC } from 'react';

import Box from '@mui/material/Box/Box';

import { Typography } from '@mui/material';
import { colors } from 'styles';
import { useNavigate } from 'react-router-dom';
import { Button } from 'components/Buttons';
import {
  ContentWrapper,
  CustomerCaseImageWrapper,
  DefaultImageWrapper,
  PageWrapper,
} from './TextWithImage.styles';
import { ICustomerCase } from 'types/customer-case';

type TextWithImageType = 'default' | 'customer-case';

interface TextWithImageProps extends ICustomerCase {
  type?: TextWithImageType;
}

// TODO: This component needs to be putter into components folder
const TextWithImage: FC<TextWithImageProps> = ({
  type = 'default',
  title,
  description,
  bottomText,
  image,
  items,
  link = '',
}) => {
  const navigate = useNavigate();
  const isDefault = type === 'default';
  const color = !isDefault ? colors.mainDark : colors.blue;

  return (
    <PageWrapper isCustomerCase={!isDefault} padding={isDefault ? '120px 0px 48px' : '112px 0px'}>
      <ContentWrapper isCustomerCase={!isDefault}>
        <Typography
          component="h3"
          fontSize={{
            md: '40px',
            xxs: '32px',
          }}
          color={color}
          fontWeight={700}
          lineHeight="120%"
          marginBottom="24px"
        >
          {title}
        </Typography>

        {isDefault && <>{description}</>}

        {!isDefault && (
          <Typography fontSize="18px" color={colors.mainDark}>
            {description}
          </Typography>
        )}

        {!isDefault && (
          <Box marginTop="24px">
            <Button width={158} onClick={() => navigate(link)}>
              Learn more
            </Button>
          </Box>
        )}

        {isDefault && items.length > 0 && (
          <>
            <Typography fontWeight={700} marginTop="24px" fontSize="18px" color={colors.mainDark}>
              Key challenges they faced:
            </Typography>

            <ul style={{ margin: '24px 0 0' }}>
              {items.map((item) => (
                <li
                  key={item}
                  style={{
                    lineHeight: '140%',
                    fontSize: '18px',
                    color: colors.mainDark,
                    margin: '8px 0',
                  }}
                >
                  {item}
                </li>
              ))}
            </ul>
          </>
        )}

        {isDefault && bottomText && (
          <Typography fontSize="18px" color={colors.mainDark} marginTop="16px">
            {bottomText}
          </Typography>
        )}
      </ContentWrapper>

      {isDefault && (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            background: colors.oliveBlack,
            borderRadius: '8px',
            width: '100%',
            maxWidth: {
              lg: '560px',
              xxs: '100%',
            },
            height: {
              md: 'auto',
              xxs: '300px',
            },
          }}
        >
          <DefaultImageWrapper>
            <img
              src={image}
              alt="application"
              style={{
                maxHeight: '100%',
                maxWidth: '100%',
                objectFit: 'contain',
              }}
            />
          </DefaultImageWrapper>
        </Box>
      )}

      {!isDefault && (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            borderRadius: '8px',
            width: '100%',
            height: {
              md: '560px',
              xxs: '300px',
            },
          }}
          marginBottom={{
            lg: 0,
            xxs: '40px',
          }}
        >
          <CustomerCaseImageWrapper>
            <img src={image} alt="application" />
          </CustomerCaseImageWrapper>
        </Box>
      )}
    </PageWrapper>
  );
};

export default TextWithImage;
